"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrokerContact = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const broker_entity_1 = require("./broker.entity");
const contact_entity_1 = require("./contact.entity");
let BrokerContact = class BrokerContact {
};
exports.BrokerContact = BrokerContact;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], BrokerContact.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "broker_id" }),
    tslib_1.__metadata("design:type", Number)
], BrokerContact.prototype, "brokerId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "contact_id" }),
    tslib_1.__metadata("design:type", Number)
], BrokerContact.prototype, "contactId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => broker_entity_1.Broker, (broker) => broker.brokerContacts, {
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "broker_id" }),
    tslib_1.__metadata("design:type", Object)
], BrokerContact.prototype, "broker", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => contact_entity_1.Contact, (contact) => contact.brokerContacts, {
        eager: true,
    }),
    (0, typeorm_1.JoinColumn)({ name: "contact_id" }),
    tslib_1.__metadata("design:type", Object)
], BrokerContact.prototype, "contact", void 0);
exports.BrokerContact = BrokerContact = tslib_1.__decorate([
    (0, typeorm_1.Entity)({ name: "broker_contact" })
], BrokerContact);
